// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/c_editb.css
// module id = 2e2R
// module chunks = 1